export const isAWSPresignedURL = (url: string): boolean => {
  try {
    const regex = /awsaccesskeyid/i;
    return regex.test(url);
  } catch {
    return false;
  }
};
